import { Box, Tab, Tabs } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useAPI from "../../../api/hooks/useAPI";
import useColors from "../../../api/hooks/useColors";
import AppPage from "../../../components/structure/AppPage";
import MitreView from "../mitre/MitreView";
import NistView from "../nist/NistView";

const FRAMEWORK_TABS = {
  MITRE: "mitre",
  NIST: "nist",
};

const FRAMEWORK_LABELS = {
  [FRAMEWORK_TABS.MITRE]: "MITRE ATT&CK",
  [FRAMEWORK_TABS.NIST]: "NIST CSF 2.0",
};

export default function FrameworksView() {
  const colors = useColors();
  const navigate = useNavigate();
  const { trackEvent } = useAPI();
  const { framework } = useParams();

  const selectedTab = framework || FRAMEWORK_TABS.MITRE;

  const handleTabChange = (_, newValue) => {
    trackEvent(`User switched to ${FRAMEWORK_LABELS[newValue]} framework tab`);
    navigate(`/frameworks/${newValue}`);
  };

  const renderFrameworkContent = () => {
    switch (selectedTab) {
      case FRAMEWORK_TABS.MITRE:
        return <MitreView />;
      case FRAMEWORK_TABS.NIST:
        return <NistView />;
      default:
        return <MitreView />;
    }
  };

  return (
    <AppPage title="Frameworks">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          sx={{
            borderBottom: `1px solid ${colors.divider}`,
            "& .MuiTabs-indicator": {
              backgroundColor: colors.primary_main,
            },
          }}
        >
          <Tab
            label={FRAMEWORK_LABELS[FRAMEWORK_TABS.MITRE]}
            value={FRAMEWORK_TABS.MITRE}
            sx={{
              textTransform: "none",
              color: colors.text_secondary,
              fontWeight: 400,
              "&.Mui-selected": {
                color: colors.text_primary,
              },
            }}
            disableRipple
          />
          <Tab
            label={FRAMEWORK_LABELS[FRAMEWORK_TABS.NIST]}
            value={FRAMEWORK_TABS.NIST}
            sx={{
              textTransform: "none",
              color: colors.text_secondary,
              fontWeight: 400,
              "&.Mui-selected": {
                color: colors.text_primary,
              },
            }}
            disableRipple
          />
        </Tabs>

        <Box>{renderFrameworkContent()}</Box>
      </Box>
    </AppPage>
  );
}
